import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Operation } from './operation'
import { operationActions } from './operation.actions'
import * as fromOperation from './operation.reducer'
import { OperationService } from './operation.service'
import {
  concatMap,
  exhaustMap,
  map,
  switchMap,
  take,
  tap
} from 'rxjs/operators'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class OperationEffects
  extends ResourceEffects<Operation>
  implements OnInitEffects
{
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public operationService: OperationService,
    public router: Router
  ) {
    super(
      fromOperation.FEATURE_NAME,
      operationService,
      operationActions,
      actions$
    )
  }

  ngrxOnInitEffects() {
    return operationActions.initActions()
  }

  operateByParams = createEffect(() =>
    this.actions$.pipe(
      ofType(operationActions.operateByParams),
      exhaustMap((action) =>
        this.operationService.operate(action.operation.id, action.params).pipe(
          map((operation) =>
            normalizationActions.upsertMany({
              entities: normalizeToSchema({ operations: [operation] })
            })
          )
        )
      )
    )
  )
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole: any
          this.store
            .select(persistentUserRoleSelectors.selectSelectedUserRole)
            .pipe(take(1))
            .subscribe((user) => {
              userRole = user
            })
          userRole && this.store.dispatch(operationActions.resetState())
        })
      ),
    { dispatch: false }
  )
  getAllMany = createEffect(() =>
    this.actions$.pipe(
      ofType(operationActions.getAllMany),
      concatMap((action) =>
        this.operationService.getAllMany(action.params).pipe(
          map((supervisorSkills: any) => {
            this.store.dispatch(
              operationActions.actionFinished({
                actionFinished: {
                  action: operationActions.getAllMany.type,
                  data: supervisorSkills
                }
              })
            )
            return normalizationActions.upsertMany({
              entities: normalizeToSchema({
                supervisorSkills: supervisorSkills
              })
            })
          })
        )
      )
    )
  )
}
